import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, CircularProgress, Grid2, Box, CardMedia } from "@mui/material";
import dataProvider from "../providers/mainProvider";

const VideoPage = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    dataProvider
      .getTutorialVideo()
      .then(data => {
        setVideos(data.videos);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [dataProvider]);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">Errore nel caricamento dei video</Typography>;

  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <Grid2 container>
        {videos && videos.map(video => (
          <Grid2 size={3} style={{ padding: 10}} key={Math.random()}>
            <Card >
              <CardMedia style={{ height: 360 }} allowFullScreen={true} component="iframe" src={"https://www.youtube.com/embed/" + video.id_video} />
              <CardContent style={{ height: 220 }}>
                <Typography variant="h6">{video.title}</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>{video.description}</Typography>
              </CardContent>
            </Card>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default VideoPage;
